import Store from './Store';
import ScheduledOrder from '../data/ressources/ScheduledOrder.json'

const ScheduledOrdersStore = new Store('scheduledOrders', ScheduledOrder);

export {ScheduledOrdersStore};